<template>
  <div id="app">
    <loading v-if="this.$store.state.loading"></loading>
    <showMsg v-if="this.$store.state.showMsg"></showMsg>
    <router-view />
  </div>
</template>
<script>
import Loading from "./components/loading";
import showMsg from "./components/showMsg";
export default {
  name: "",
  data() {
    return {
      UserInfo: "",
      openid: ""
    };
  },
  components: {
    Loading,
    showMsg
  },
  created() {},
  mounted() {
    this.$store.commit("CShttp", this.$CShttp);
    this.$store.commit("ZChttp", this.$ZChttp);
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
  },
  methods: {}
};
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
a {
  text-decoration: none;
  color: black;
}
/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
  text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: none;
}
/* 正在点击的链接*/
a:active {
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
</style>
